export default "__VITE_ASSET__BN8OJf1$__"